import { Property } from "@stratify/shared";
import React from "react";
import { GenericAgentChatTab } from "../../agentChat/components/GenericAgentChatTab";
import { AgentContext } from "../../agentChat/types/agentConfig";

interface PropertyAgentChatTabProps {
  property: Property;
  userId: string;
}

export const PropertyAgentChatTab: React.FC<PropertyAgentChatTabProps> = ({ 
  property, 
  userId 
}) => {
  // Create property agent context
  const context: AgentContext = {
    contextId: property.id,
    agentType: 'property',
    userId: userId,
    contextData: property,
  };

  // Use generic chat tab component
  return <GenericAgentChatTab context={context} />;
};